import script from "./SpinningLoaderInline.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpinningLoaderInline.vue?vue&type=script&setup=true&lang=ts"

import "./SpinningLoaderInline.vue?vue&type=style&index=0&id=a8e7b116&scoped=true&lang=css"

import exportComponent from "/node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8e7b116"]])

export default __exports__